import {
    amendHpPostBodyFromData,
    createHpDeviceDraftPostBody,
    createHpPostBodyFromData,
} from "./hpSpec"
import {
    TAmendAcuDevicePostBody,
    TPublishAcuDevicePostBody,
    TSaveAcuDeviceDraftPostBody,
} from "../../../../services/middleware/types/devices/lct/publishAcuDeviceTypes"
import { HpDeviceFormData } from "../types/providerTypes"

export const ACU_FUNCTIONS = ["N/A"]
export const ACU_TYPES = ["Air Conditioning Unit"]

/**
 * Generates create ACU post body from form data.
 * Mirrors the HP post body exactly, overriding only device_type.
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @returns {TPublishAcuDevicePostBody} - the post body for the publish LCT device request
 */
export const createAcuPostBodyFromData = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    systemReference?: string
): TPublishAcuDevicePostBody => {
    const hpBody = createHpPostBodyFromData(
        formData,
        attachmentUUID,
        systemReference
    )
    return {
        ...hpBody,
        device_type: "ACU",
        device_data: {
            ...hpBody.device_data,
            LCTDeviceType: "ACU",
        },
    }
}

/**
 * Generates the save-draft ACU post body from form data.
 * Mirrors the HP draft post body exactly, overriding only device_type.
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @param {boolean} isAmendment - whether the draft is for an amendment
 * @returns {TSaveAcuDeviceDraftPostBody} - the post body for the save draft request
 */
export const createAcuDeviceDraftPostBody = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    isAmendment: boolean,
    systemReference?: string
): TSaveAcuDeviceDraftPostBody => {
    const hpBody = createHpDeviceDraftPostBody(
        formData,
        attachmentUUID,
        isAmendment,
        systemReference
    )
    return {
        ...hpBody,
        device_type: "ACU",
        device_data: {
            ...hpBody.device_data,
            LCTDeviceType: "ACU",
        },
    }
}

/**
 * Generates the amend ACU post body from form data.
 * Mirrors the HP amend post body exactly, overriding only device_type.
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @param {string} systemReference - the device system reference
 * @returns {TAmendAcuDevicePostBody} - the post body for the amend LCT device request
 */
export const amendAcuPostBodyFromData = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    systemReference: string
): TAmendAcuDevicePostBody => {
    const hpBody = amendHpPostBodyFromData(
        formData,
        attachmentUUID,
        systemReference
    )
    return {
        ...hpBody,
        device_type: "ACU",
        device_data: {
            ...hpBody.device_data,
            LCTDeviceType: "ACU",
        },
    }
}
